"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getManageAccountInnBusinessTabDropdownItems = exports.AccountActionsTypes = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _api = require("@whitbread-eos/api");
var _formatters = require("../formatters");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var AccountActionsTypes = exports.AccountActionsTypes = function (AccountActionsTypes) {
  AccountActionsTypes[AccountActionsTypes["SET_RESET_MEMORABLE_WORD"] = 0] = "SET_RESET_MEMORABLE_WORD";
  AccountActionsTypes[AccountActionsTypes["EDIT_ACCOUNT_DETAILS"] = 1] = "EDIT_ACCOUNT_DETAILS";
  AccountActionsTypes[AccountActionsTypes["MANAGE_EMPLOYEES"] = 2] = "MANAGE_EMPLOYEES";
  AccountActionsTypes[AccountActionsTypes["CARD_MANAGEMENT"] = 3] = "CARD_MANAGEMENT";
  AccountActionsTypes[AccountActionsTypes["VIEW_OFFERS"] = 4] = "VIEW_OFFERS";
  AccountActionsTypes[AccountActionsTypes["LINK_EXISTING_ACCOUNT"] = 5] = "LINK_EXISTING_ACCOUNT";
  AccountActionsTypes[AccountActionsTypes["APPLY_NEW_ACCOUNT"] = 6] = "APPLY_NEW_ACCOUNT";
  return AccountActionsTypes;
}({});
var getManageAccountInnBusinessTabDropdownItems = exports.getManageAccountInnBusinessTabDropdownItems = function getManageAccountInnBusinessTabDropdownItems(locale, roles, accessLevel) {
  var wlHost = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var tetherGuid = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var AccountActionsMap = {
    [AccountActionsTypes.SET_RESET_MEMORABLE_WORD]: {
      label: 'spending.manage.account.memorable.word.setOrReset',
      href: (0, _formatters.getPathForLocale)(locale, "spending/memorable-word".concat(tetherGuid ? "?account=".concat(tetherGuid) : ''))
    },
    [AccountActionsTypes.EDIT_ACCOUNT_DETAILS]: {
      label: 'spending.manage.account.accountDetails',
      href: 'Account.aspx',
      isExternal: true
    },
    [AccountActionsTypes.MANAGE_EMPLOYEES]: {
      label: 'spending.manage.account.manageEmployees',
      href: (0, _formatters.getPathForLocale)(locale, 'manage/employees?tab=innbusiness-pay')
    },
    [AccountActionsTypes.CARD_MANAGEMENT]: {
      label: 'spending.manage.account.cardManagement',
      href: (0, _formatters.getPathForLocale)(locale, 'manage/cards?tab=innbusiness-pay')
    },
    [AccountActionsTypes.VIEW_OFFERS]: {
      label: 'spending.manage.account.viewOffers',
      href: 'ViewMyOffers.aspx',
      isExternal: true
    },
    [AccountActionsTypes.LINK_EXISTING_ACCOUNT]: {
      label: 'spending.manage.account.link',
      href: "".concat(wlHost, "/BBLinkCode.aspx")
    },
    [AccountActionsTypes.APPLY_NEW_ACCOUNT]: {
      label: 'spending.manage.account.create',
      href: (0, _formatters.getPathForLocale)(locale, 'business-account/apply')
    }
  };
  var mat = {
    SUPER: {
      [_api.RegistrationRole.AccountHolder]: [AccountActionsMap[AccountActionsTypes.SET_RESET_MEMORABLE_WORD], AccountActionsMap[AccountActionsTypes.EDIT_ACCOUNT_DETAILS], AccountActionsMap[AccountActionsTypes.MANAGE_EMPLOYEES], AccountActionsMap[AccountActionsTypes.CARD_MANAGEMENT], AccountActionsMap[AccountActionsTypes.VIEW_OFFERS], AccountActionsMap[AccountActionsTypes.LINK_EXISTING_ACCOUNT], AccountActionsMap[AccountActionsTypes.APPLY_NEW_ACCOUNT]],
      [_api.RegistrationRole.FinanceUser]: [AccountActionsMap[AccountActionsTypes.SET_RESET_MEMORABLE_WORD], AccountActionsMap[AccountActionsTypes.LINK_EXISTING_ACCOUNT], AccountActionsMap[AccountActionsTypes.APPLY_NEW_ACCOUNT]],
      [_api.RegistrationRole.CardHolder]: [AccountActionsMap[AccountActionsTypes.SET_RESET_MEMORABLE_WORD], AccountActionsMap[AccountActionsTypes.CARD_MANAGEMENT], AccountActionsMap[AccountActionsTypes.LINK_EXISTING_ACCOUNT], AccountActionsMap[AccountActionsTypes.APPLY_NEW_ACCOUNT]]
    },
    USER: {
      [_api.RegistrationRole.AccountHolder]: [AccountActionsMap[AccountActionsTypes.SET_RESET_MEMORABLE_WORD], AccountActionsMap[AccountActionsTypes.EDIT_ACCOUNT_DETAILS], AccountActionsMap[AccountActionsTypes.VIEW_OFFERS], AccountActionsMap[AccountActionsTypes.LINK_EXISTING_ACCOUNT]],
      [_api.RegistrationRole.FinanceUser]: [AccountActionsMap[AccountActionsTypes.SET_RESET_MEMORABLE_WORD], AccountActionsMap[AccountActionsTypes.LINK_EXISTING_ACCOUNT]],
      [_api.RegistrationRole.CardHolder]: [AccountActionsMap[AccountActionsTypes.SET_RESET_MEMORABLE_WORD], AccountActionsMap[AccountActionsTypes.CARD_MANAGEMENT], AccountActionsMap[AccountActionsTypes.LINK_EXISTING_ACCOUNT]]
    }
  };
  var structure = [[AccountActionsTypes.SET_RESET_MEMORABLE_WORD], [AccountActionsTypes.EDIT_ACCOUNT_DETAILS, AccountActionsTypes.MANAGE_EMPLOYEES, AccountActionsTypes.CARD_MANAGEMENT, AccountActionsTypes.VIEW_OFFERS], [AccountActionsTypes.LINK_EXISTING_ACCOUNT, AccountActionsTypes.APPLY_NEW_ACCOUNT]];
  var flatItems = Array.from(new Set(roles.map(role => mat[accessLevel === 'SUPER' ? 'SUPER' : 'USER'][role]).flatMap(item => Object.values(item || {}))));
  return structure.map(group => group.map(action => {
    var item = flatItems.find(item => item === AccountActionsMap[action]);
    return item ? _objectSpread({}, item) : null;
  }).filter(item => item !== null)).filter(group => group.length > 0);
};